<template>
  <section>
    <form @submit.prevent="submit">
      <Field
        label="First Name"
        @input="$v.resource.firstName.$touch()"
        v-model="resource.firstName"
        :error="firstNameError"
      />

      <Field
        label="Last Name"
        @input="$v.resource.lastName.$touch()"
        v-model="resource.lastName"
        :error="lastNameError"
      />

      <Field
        label="Company Name"
        @input="$v.resource.companyName.$touch()"
        v-model="resource.companyName"
        :error="companyNameError"
      />

      <Field
        label="Email Address"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"
      />

      <Field
        label="Phone"
        @input="$v.resource.phone.$touch()"
        v-model="resource.phone"
        :error="phoneError"
      />

      <Field
        label="Address Line 1"
        @input="$v.resource.address1.$touch()"
        v-model="resource.address1"
        :error="address1Error"
      />

      <Field
        label="Address Line 2"
        @input="$v.resource.address2.$touch()"
        v-model="resource.address2"
        :error="address2Error"
      />

      <Field
        label="City/Town"
        @input="$v.resource.city.$touch()"
        v-model="resource.city"
        :error="cityError"
      />

      <Field
        label="County/State"
        @input="$v.resource.state.$touch()"
        v-model="resource.state"
        :error="stateError"
      />

      <Field
        label="Postal/Zip Code"
        @input="$v.resource.zip.$touch()"
        v-model="resource.zip"
        :error="zipError"
      />

      <Field
        label="Country"
        type="select"
        :options="countries"
        @input="$v.resource.country.$touch()"
        v-model="resource.country"
        :error="countryError"
      />

      <div class="btn-save">
        <Btn
          :isDisabled="$v.$invalid"
          :isLoading="btnLoading"
          primary>
          Save and Continue
        </Btn>
      </div>
    </form>
  </section>
</template>

<script>
import form from '@/mixins/form'
import countries from '@/mixins/countries'

import Btn from '@/components/Btn'

import {mapState} from 'vuex'

import {errorMessages} from '@/lib/error_messages'
import {required, email} from 'vuelidate/lib/validators'

export default {
  name: 'domain-contact-form',

  mixins: [form, countries],

  props: {
    companyName: String,
    btnLoading: Boolean
  },

  computed: {
    ...errorMessages([
      'firstName',
      'lastName',
      'companyName',
      'email',
      'phone',
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'country'
    ]),
    ...mapState(['currentUser']),

    firstName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[0]
    },

    lastName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[1]
    }
  },

  methods: {
    populateFields() {
      this.resource.firstName = this.firstName
      this.resource.lastName = this.lastName
      this.resource.email = this.currentUser.email
      this.resource.companyName = this.companyName
    }
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      firstName: {required},
      lastName: {required},
      companyName: {required},
      email: {required, email},
      phone: {required},
      address1: {required},
      address2: {},
      city: {required},
      state: {required},
      zip: {required},
      country: {required}
    }
  },

  mounted() {
    this.populateFields()
  },

  watch: {
    companyName() {
      this.populateFields()
    }
  }
}
</script>
